// extracted by mini-css-extract-plugin
export default {"container":"allUsers_container__Zv-Uw","label":"allUsers_label__tyA2Q","title":"allUsers_title__Q-Xe8"};